export default function ChartTooltip({ active, payload, label }) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="bg-white border border-[#E8ECF0] rounded-[9px] px-3 py-2 shadow-[0_4px_16px_rgba(0,0,0,.09)] text-[12px]">
      {label && <div className="font-bold text-[#1E293B] mb-1">{label}</div>}
      {payload.map((p, i) => (
        <div key={i} className="flex items-center gap-1.5 text-[#64748B] py-px">
          <span className="w-2 h-2 rounded-full shrink-0" style={{ background: p.fill || p.color }} />
          {p.name}: <strong className="text-[#1E293B] ml-0.5">{p.value}</strong>
        </div>
      ))}
    </div>

  );
}
